export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/tr.lyaml"));
at({ "tr": { "public": { "sampleString": "\xD6rnek dize" } } });
};